/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppChatRouteImport } from './routes/_app/chat'
import { Route as AppInboxRouteImport } from './routes/_app/inbox'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as LoginSentRouteImport } from './routes/login_.sent'
import { Route as MAuthRouteImport } from './routes/m.auth'
import { Route as AppProjectsIndexRouteImport } from './routes/_app/projects/index'
import { Route as AppProjectsProjectIdRouteImport } from './routes/_app/projects/$projectId'
import { Route as AppReportsIndexRouteImport } from './routes/_app/reports/index'
import { Route as AppReportsReportIdRouteImport } from './routes/_app/reports/$reportId'
import { Route as AppSettingsIndexRouteImport } from './routes/_app/settings/index'
import { Route as AppSettingsTeamRouteImport } from './routes/_app/settings/team'
import { Route as AppSettingsTokensRouteImport } from './routes/_app/settings/tokens'
import { Route as AppProjectsProjectIdIndexRouteImport } from './routes/_app/projects/$projectId/index'
import { Route as AppProjectsProjectIdActivityRouteImport } from './routes/_app/projects/$projectId/activity'
import { Route as AppProjectsProjectIdSourcesRouteImport } from './routes/_app/projects/$projectId/sources'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppChatRoute = AppChatRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => AppRoute,
} as any)
const AppInboxRoute = AppInboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginSentRoute = LoginSentRouteImport.update({
  id: '/login_/sent',
  path: '/login/sent',
  getParentRoute: () => rootRouteImport,
} as any)
const MAuthRoute = MAuthRouteImport.update({
  id: '/m/auth',
  path: '/m/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AppProjectsIndexRoute = AppProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsProjectIdRoute = AppProjectsProjectIdRouteImport.update({
  id: '/projects/$projectId',
  path: '/projects/$projectId',
  getParentRoute: () => AppRoute,
} as any)
const AppReportsIndexRoute = AppReportsIndexRouteImport.update({
  id: '/reports/',
  path: '/reports/',
  getParentRoute: () => AppRoute,
} as any)
const AppReportsReportIdRoute = AppReportsReportIdRouteImport.update({
  id: '/reports/$reportId',
  path: '/reports/$reportId',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsTeamRoute = AppSettingsTeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsTokensRoute = AppSettingsTokensRouteImport.update({
  id: '/tokens',
  path: '/tokens',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppProjectsProjectIdIndexRoute =
  AppProjectsProjectIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppProjectsProjectIdRoute,
  } as any)
const AppProjectsProjectIdActivityRoute =
  AppProjectsProjectIdActivityRouteImport.update({
    id: '/activity',
    path: '/activity',
    getParentRoute: () => AppProjectsProjectIdRoute,
  } as any)
const AppProjectsProjectIdSourcesRoute =
  AppProjectsProjectIdSourcesRouteImport.update({
    id: '/sources',
    path: '/sources',
    getParentRoute: () => AppProjectsProjectIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/chat': typeof AppChatRoute
  '/inbox': typeof AppInboxRoute
  '/settings': typeof AppSettingsRouteWithChildren
  '/auth/callback': typeof AuthCallbackRoute
  '/login/sent': typeof LoginSentRoute
  '/m/auth': typeof MAuthRoute
  '/projects/$projectId': typeof AppProjectsProjectIdRouteWithChildren
  '/reports/$reportId': typeof AppReportsReportIdRoute
  '/settings/team': typeof AppSettingsTeamRoute
  '/settings/tokens': typeof AppSettingsTokensRoute
  '/projects/': typeof AppProjectsIndexRoute
  '/reports/': typeof AppReportsIndexRoute
  '/settings/': typeof AppSettingsIndexRoute
  '/projects/$projectId/activity': typeof AppProjectsProjectIdActivityRoute
  '/projects/$projectId/sources': typeof AppProjectsProjectIdSourcesRoute
  '/projects/$projectId/': typeof AppProjectsProjectIdIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/chat': typeof AppChatRoute
  '/inbox': typeof AppInboxRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/login/sent': typeof LoginSentRoute
  '/m/auth': typeof MAuthRoute
  '/': typeof AppIndexRoute
  '/reports/$reportId': typeof AppReportsReportIdRoute
  '/settings/team': typeof AppSettingsTeamRoute
  '/settings/tokens': typeof AppSettingsTokensRoute
  '/projects': typeof AppProjectsIndexRoute
  '/reports': typeof AppReportsIndexRoute
  '/settings': typeof AppSettingsIndexRoute
  '/projects/$projectId/activity': typeof AppProjectsProjectIdActivityRoute
  '/projects/$projectId/sources': typeof AppProjectsProjectIdSourcesRoute
  '/projects/$projectId': typeof AppProjectsProjectIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/_app/chat': typeof AppChatRoute
  '/_app/inbox': typeof AppInboxRoute
  '/_app/settings': typeof AppSettingsRouteWithChildren
  '/auth/callback': typeof AuthCallbackRoute
  '/login_/sent': typeof LoginSentRoute
  '/m/auth': typeof MAuthRoute
  '/_app/': typeof AppIndexRoute
  '/_app/projects/$projectId': typeof AppProjectsProjectIdRouteWithChildren
  '/_app/reports/$reportId': typeof AppReportsReportIdRoute
  '/_app/settings/team': typeof AppSettingsTeamRoute
  '/_app/settings/tokens': typeof AppSettingsTokensRoute
  '/_app/projects/': typeof AppProjectsIndexRoute
  '/_app/reports/': typeof AppReportsIndexRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
  '/_app/projects/$projectId/activity': typeof AppProjectsProjectIdActivityRoute
  '/_app/projects/$projectId/sources': typeof AppProjectsProjectIdSourcesRoute
  '/_app/projects/$projectId/': typeof AppProjectsProjectIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/chat'
    | '/inbox'
    | '/settings'
    | '/auth/callback'
    | '/login/sent'
    | '/m/auth'
    | '/projects/$projectId'
    | '/reports/$reportId'
    | '/settings/team'
    | '/settings/tokens'
    | '/projects/'
    | '/reports/'
    | '/settings/'
    | '/projects/$projectId/activity'
    | '/projects/$projectId/sources'
    | '/projects/$projectId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/chat'
    | '/inbox'
    | '/auth/callback'
    | '/login/sent'
    | '/m/auth'
    | '/'
    | '/reports/$reportId'
    | '/settings/team'
    | '/settings/tokens'
    | '/projects'
    | '/reports'
    | '/settings'
    | '/projects/$projectId/activity'
    | '/projects/$projectId/sources'
    | '/projects/$projectId'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/_app/chat'
    | '/_app/inbox'
    | '/_app/settings'
    | '/auth/callback'
    | '/login_/sent'
    | '/m/auth'
    | '/_app/'
    | '/_app/projects/$projectId'
    | '/_app/reports/$reportId'
    | '/_app/settings/team'
    | '/_app/settings/tokens'
    | '/_app/projects/'
    | '/_app/reports/'
    | '/_app/settings/'
    | '/_app/projects/$projectId/activity'
    | '/_app/projects/$projectId/sources'
    | '/_app/projects/$projectId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  LoginSentRoute: typeof LoginSentRoute
  MAuthRoute: typeof MAuthRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/chat': {
      id: '/_app/chat'
      path: '/chat'
      fullPath: '/chat'
      preLoaderRoute: typeof AppChatRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/inbox': {
      id: '/_app/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof AppInboxRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login_/sent': {
      id: '/login_/sent'
      path: '/login/sent'
      fullPath: '/login/sent'
      preLoaderRoute: typeof LoginSentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/m/auth': {
      id: '/m/auth'
      path: '/m/auth'
      fullPath: '/m/auth'
      preLoaderRoute: typeof MAuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/projects/': {
      id: '/_app/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof AppProjectsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects/$projectId': {
      id: '/_app/projects/$projectId'
      path: '/projects/$projectId'
      fullPath: '/projects/$projectId'
      preLoaderRoute: typeof AppProjectsProjectIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reports/': {
      id: '/_app/reports/'
      path: '/reports'
      fullPath: '/reports/'
      preLoaderRoute: typeof AppReportsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reports/$reportId': {
      id: '/_app/reports/$reportId'
      path: '/reports/$reportId'
      fullPath: '/reports/$reportId'
      preLoaderRoute: typeof AppReportsReportIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/team': {
      id: '/_app/settings/team'
      path: '/team'
      fullPath: '/settings/team'
      preLoaderRoute: typeof AppSettingsTeamRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/tokens': {
      id: '/_app/settings/tokens'
      path: '/tokens'
      fullPath: '/settings/tokens'
      preLoaderRoute: typeof AppSettingsTokensRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/projects/$projectId/': {
      id: '/_app/projects/$projectId/'
      path: '/'
      fullPath: '/projects/$projectId/'
      preLoaderRoute: typeof AppProjectsProjectIdIndexRouteImport
      parentRoute: typeof AppProjectsProjectIdRoute
    }
    '/_app/projects/$projectId/activity': {
      id: '/_app/projects/$projectId/activity'
      path: '/activity'
      fullPath: '/projects/$projectId/activity'
      preLoaderRoute: typeof AppProjectsProjectIdActivityRouteImport
      parentRoute: typeof AppProjectsProjectIdRoute
    }
    '/_app/projects/$projectId/sources': {
      id: '/_app/projects/$projectId/sources'
      path: '/sources'
      fullPath: '/projects/$projectId/sources'
      preLoaderRoute: typeof AppProjectsProjectIdSourcesRouteImport
      parentRoute: typeof AppProjectsProjectIdRoute
    }
  }
}

interface AppSettingsRouteChildren {
  AppSettingsTeamRoute: typeof AppSettingsTeamRoute
  AppSettingsTokensRoute: typeof AppSettingsTokensRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
}

const AppSettingsRouteChildren: AppSettingsRouteChildren = {
  AppSettingsTeamRoute: AppSettingsTeamRoute,
  AppSettingsTokensRoute: AppSettingsTokensRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
}

const AppSettingsRouteWithChildren = AppSettingsRoute._addFileChildren(
  AppSettingsRouteChildren,
)

interface AppProjectsProjectIdRouteChildren {
  AppProjectsProjectIdActivityRoute: typeof AppProjectsProjectIdActivityRoute
  AppProjectsProjectIdSourcesRoute: typeof AppProjectsProjectIdSourcesRoute
  AppProjectsProjectIdIndexRoute: typeof AppProjectsProjectIdIndexRoute
}

const AppProjectsProjectIdRouteChildren: AppProjectsProjectIdRouteChildren = {
  AppProjectsProjectIdActivityRoute: AppProjectsProjectIdActivityRoute,
  AppProjectsProjectIdSourcesRoute: AppProjectsProjectIdSourcesRoute,
  AppProjectsProjectIdIndexRoute: AppProjectsProjectIdIndexRoute,
}

const AppProjectsProjectIdRouteWithChildren =
  AppProjectsProjectIdRoute._addFileChildren(AppProjectsProjectIdRouteChildren)

interface AppRouteChildren {
  AppChatRoute: typeof AppChatRoute
  AppInboxRoute: typeof AppInboxRoute
  AppSettingsRoute: typeof AppSettingsRouteWithChildren
  AppIndexRoute: typeof AppIndexRoute
  AppProjectsProjectIdRoute: typeof AppProjectsProjectIdRouteWithChildren
  AppReportsReportIdRoute: typeof AppReportsReportIdRoute
  AppProjectsIndexRoute: typeof AppProjectsIndexRoute
  AppReportsIndexRoute: typeof AppReportsIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppChatRoute: AppChatRoute,
  AppInboxRoute: AppInboxRoute,
  AppSettingsRoute: AppSettingsRouteWithChildren,
  AppIndexRoute: AppIndexRoute,
  AppProjectsProjectIdRoute: AppProjectsProjectIdRouteWithChildren,
  AppReportsReportIdRoute: AppReportsReportIdRoute,
  AppProjectsIndexRoute: AppProjectsIndexRoute,
  AppReportsIndexRoute: AppReportsIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  LoginSentRoute: LoginSentRoute,
  MAuthRoute: MAuthRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
